import { APP, WS_DATA } from './app.constants';

export const TEAMS = `${APP}_teams`;
export const SELECT_TEAM = `${TEAMS}/SELECT_TEAM`;
export const SAVE_TEAM = `${TEAMS}/SAVE_TEAM`;
export const DELETE_TEAM = `${TEAMS}/DELETE_TEAM`;

export const WS_DATA_TEAM = `${WS_DATA}/team`;
export const WS_DATA_TEAMS = `${WS_DATA}/teams`;